<div class="form-inner-cont">
  <div class="w3l-form-25" style="display: flex; justify-content: center">
    <h1 style="color: rgb(79, 79, 161); font-weight: bolder">
      {{ "Rounds and Clinics" | translate }}
    </h1>
  </div>
</div>

<BR />
<div id="w3l-appointment">
  <div class="wrapper d-grid doctor-appointment">
    <form action="#" method="post">
      <div class="appointment-form-field">
        <label style="width: 70px">{{ "Patient " | translate }}</label>
        <input
          type="text"
          name="patientcode"
          required=""
          style="width: 112px"
          [(ngModel)]="patientcode"
          (change)="RertivePatient()"
        />
        <span
          class="fa fa-search"
          aria-hidden="true"
          style="cursor: grab"
          (click)="OpenEmployeeDialog()"
        ></span>
        <label
          id="w3l-appointment"
          class="appointment-form-field"
          [(ngModel)]="patientFName"
          style="
            width: 600px;
            background-color: rgb(187, 203, 238);
            border-style: solid;
            border-width: 0.5px;
            border-color: slategray;
          "
          >{{ patientFName }}</label
        >
        <a
          target="_blank"
          (click)="RoundAndClinicOpen()"
          style="padding-left: 20px"
        >
          <button
            class="icon-btn fa fa-hospital-o"
            matTooltip="Rounds and Clinic"
            matTooltipClass="bigTooltip"
          ></button
        ></a>
      </div>
    </form>
  </div>
</div>

<section style="display: flex; justify-content: center; padding-top: 2%">
  <mat-tab-group animationDuration="2000ms"  style="width: 1300px;  align-items: center;">
      <mat-tab  label="Laboratory"  style="width: 50%; padding-left: 10%; height: 100%;" >
      <BR>
      <textarea  placeholder="Enter details here" id="lab"  name = "Laboratory"  class="appointment-fosrm-field" [(ngModel)]="Laboratory"></textarea>
      <br>
      <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="submitLaboratory()" >{{'Submit' | translate}}</button>
      </mat-tab>
      <!--         toxicity         -->
    <mat-tab label="Toxicity and Management" style="width: 50%; padding-left: 10%;">
      <BR>
      <textarea  placeholder="Enter details here" id="Toxicity"  name = "Toxicity"  class="appointment-form-field" [(ngModel)]="toxicity"  >  </textarea><br>
      <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="submittoxicity()"  >{{'Submit' | translate}}</button>
      </mat-tab>
      <!--         ClinicReferral               -->
      <mat-tab label="Clinic Referral" style="width: 50%; padding-left: 10%; height: 100%;">
      <BR>
      <textarea   placeholder="Enter details here" id="ClinicReferral"  name = "ClinicReferral"  class="appointment-fosrm-field" [(ngModel)]="ClinicReferral"></textarea>
      <br>
      <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="submitClinicReferral()" >{{'Submit' | translate}}</button>
      </mat-tab>
      <!--         Response               -->
      <mat-tab label="Response" style="width: 50%; padding-left: 10%; height: 100%; ">
      <BR>
      <textarea   placeholder="Enter details here" id="Response"  name = "Response"  class="appointment-fosrm-field" [(ngModel)]="Response"></textarea>
      <br>
      <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="submitResponse()" >{{'Submit' | translate}}</button>
      </mat-tab>

            <!--         Drug Interactions               -->
      <mat-tab label="Drug \ Drug Interactions" style="width: 50%; padding-left: 10%; height: 100%;">
      <BR>
      <textarea   placeholder="Enter details here" id="Drug Interactions"  name = "Drug Interactions"  class="appointment-fosrm-field" [(ngModel)]="DrugInteractions"></textarea>
      <br>
      <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="submitDrugInteractions()" >{{'Submit' | translate}}</button>
      </mat-tab>

                  <!--         Hypersensitivity               -->
      <mat-tab label="Hypersensitivity" style="width: 50%; padding-left: 10%; height: 100%;">
      <BR>
      <textarea   placeholder="Enter details here" id="Hypersensitivity"  name = "Hypersensitivity"  class="appointment-fosrm-field" [(ngModel)]="Hypersensitive"></textarea>
      <br>
      <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="submitHypersensitive()" >{{'Submit' | translate}}</button>
      </mat-tab>
                        <!--         Patient Education               -->
      <mat-tab label="Patient Education" style="width: 50%; padding-left: 10%; height: 100%;">
      <BR>
      <textarea placeholder="Enter details here" id="PatientEducation"  name = "PatientEducation"  class="appointment-fosrm-field" [(ngModel)]="PatientEducation"></textarea>
      <br>
      <button mat-raised-button style="width:30%;height: 50px; font-size: 85%; font-weight: bold;background-color: #143d7b;color: white;" (click)="submitPatientEducation()" >{{'Submit' | translate}}</button>
      </mat-tab>
    </mat-tab-group>
</section>
